import { render, staticRenderFns } from "./EffectTab.vue?vue&type=template&id=2ae31773"
import script from "./EffectTab.vue?vue&type=script&lang=js"
export * from "./EffectTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports